import e from "./chunk899.js";
const o = e;
export {
  o as default
};
